import merge from 'lodash/merge';
import { allFeatureFlagsAccessed } from '@atlaskit/react-ufo/feature-flags-accessed';
import sendExperienceAnalyticsLegacy, {
	type ExperienceDescription,
} from '@jira/platform__experience-tracking-analytics/src/index.tsx';
import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';

const isSynthetic = () => getMeta('ajs-is-synthetic') === 'true';

/**
 * sendExperienceAnalytics helper that is sampling events per user.
 *
 * @param {ExperienceDescription} experienceDescription - Description of the experience
 */
export function sendExperienceAnalytics(experienceDescription: ExperienceDescription): void {
	const additionalContext = {};

	const shard = getMeta('ajs-shard');
	const region = getMeta('ajs-region');
	Object.assign(additionalContext, { shard, region });

	const enabledFeatureFlags = Object.fromEntries(
		[...allFeatureFlagsAccessed].filter(([, value]) => value),
	);
	Object.assign(additionalContext, { enabledFeatureFlags });

	const synthetics = {
		additionalAttributes: {
			synthetic: isSynthetic(),
			...additionalContext,
		},
	};

	merge(experienceDescription, synthetics);
	sendExperienceAnalyticsLegacy(experienceDescription);
}
